/**
 * WB4.7 — high-tier action confirmation gate (Popconfirm / Modal.confirm).
 */

import { Modal } from 'antd';
import {
  requiresPopconfirmGate,
  resolvePopconfirmCopy,
} from '@shared/business-workbench/workbench-action-recoverability';

export function requestWorkbenchActionConfirmation(input: {
  handlerRef: string;
  actionLabel: string;
}): Promise<boolean> {
  if (!requiresPopconfirmGate(input.handlerRef)) {
    return Promise.resolve(true);
  }

  if (typeof window === 'undefined') {
    return Promise.resolve(true);
  }

  const copy = resolvePopconfirmCopy(input.handlerRef, input.actionLabel);

  return new Promise((resolve) => {
    Modal.confirm({
      title: copy.title,
      content: copy.description,
      okText: copy.okText,
      cancelText: copy.cancelText,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
